import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { Header } from 'components/Header'
import { URL_HELPDESK } from './constants'

const HELPDESK_URL = `${URL_HELPDESK}/articles/35153007205145-Informasi-Pemeliharaan-Sistem-Pengangkatan-KSPS`

const MaintenanceModePage = () => {
  return (
    <div className="flex flex-col h-screen max-w-xl mx-auto">
      <Header
        titlePosition="left"
        backHref="/home"
        iconLeftSrc="/icon/arrow-left.svg"
        hasBackButton
      />
      <div className="p-6 h-screen flex flex-col justify-center">
        <div className="flex mb-4">
          <Image
            width={120}
            height={120}
            src="/images/errors/img-error-fixing-maintenance.png"
            alt="Sedang Dalam Perbaikan"
          />
        </div>

        <Text variant="heading-md">Sistem Dalam Pemeliharaan</Text>
        <Text color="subdued" className="mt-2">
          Kemendikdasmen sedang melakukan pemeliharaan sistem teknologi yang
          berdampak pada akses fitur Seleksi Kepala Sekolah.
        </Text>
        <br />
        <Text color="subdued" className="mt-2">
          Silakan periksa secara berkala dan lihat informasi lebih lengkap
          terkait pemeliharaan sistem di Pusat Bantuan.
        </Text>

        <Link href={HELPDESK_URL} passHref>
          <Button size="lg" color="black" className="mt-5">
            Selengkapnya
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default MaintenanceModePage
